import {URL_TYPE} from './types';

export const getUrl = data => ({
  type: URL_TYPE,
  payload: data,
});
